import React, { useState, useEffect, useRef } from "react";

import "./cover.css";

import { auth } from "./firebase";

//import Checkbox from "@material-ui/core/Checkbox";
import LinearIndeterminate from "./loading.js";

import { database } from "./firebase";
import { getDatabase, ref, onValue, update } from "firebase/database";
import Navigation from "./navigation";

import NotesNav from "./NotesNav";

//import pic from "./pexels-pixabay-268415.jpg" ;

const Cover = () => {
  // let uid = auth.currentUser.uid;
  const [newData, setNewData] = useState([]);
  const [loadingApp1, setLoadingApp1] = useState(true);
  // const [loadingApp2, setLoadingApp2] = useState(true);
  let MainUserUID = auth.currentUser.uid;
  const [getUsers, setGetUsers] = useState([]);

  useEffect(() => {
    let stop = false;
    if (stop) return;
    database.ref("Owner/" + MainUserUID).on("value", (snapshot) => {
      const accounts = snapshot.val();
      // console.log(accounts);
      let allAccounts = [];
      for (let id in accounts) {
        allAccounts.push({ id, ...accounts[id] });
      }

      setGetUsers(allAccounts.filter((el) => el.MAINuserId));
    });

    //  setLoadingApp1(false);

    return () => {
      database.ref("Owner/" + MainUserUID).off();
      stop = true;
    };
  }, [MainUserUID]);

  // console.log(getUsers);
  const [uid, setUID] = useState("");
  const renderRef = useRef(true);
  useEffect(() => {
    if (renderRef.current) {
      renderRef.current = false;
      return;
    }
    getUsers.map((el) => setUID(el.MAINuserId));
  }, [getUsers]);

  // console.log(uid, MainUserUID);

  useEffect(() => {
    const urlDb = "/UserSelections/" + MainUserUID;
    const newUrlDb = database.ref(urlDb);
    setLoadingApp1(true);
    newUrlDb.on("value", (snapshot) => {
      const accounts = snapshot.val();
      //   console.log(snapshot.val());

      let newAccounts = [];

      newAccounts.push({ ...accounts });

      setNewData(newAccounts);
    });
    setLoadingApp1(false);
  }, [MainUserUID]);
  const [companySelectedIdKey, setcompanySelectedIdKey] = useState([]);

  useEffect(() => {
    setcompanySelectedIdKey(newData.map((el) => el.companySelected).toString());
  }, [newData]);

  //this sets the style of the navbar name when component loads
  const [stylingOnClickCover, setStylingOnClickCover] = useState();
  useEffect(() => {
    setStylingOnClickCover("MediumBlue");
  }, []);

  const [noBusinessSelected, setnoBusinessSelected] = useState();
  useEffect(() => {
    let storage = localStorage.getItem("noSelection");
    setnoBusinessSelected(storage);
  }, []);
  // function longDateWording(el) {
  //   let dateNumber = el.slice(8, 11);
  //   let dateMonth = el.slice(5, 6);
  //   let dateMonthValue = (dateMonth = "02"
  //     ? "February"
  //     : "03"
  //     ? "March"
  //     : "04"
  //     ? "April"
  //     : "05"
  //     ? "May"
  //     : "06"
  //     ? "June"
  //     : "07"
  //     ? "July"
  //     : "08"
  //     ? "August"
  //     : "09"
  //     ? "September"
  //     : "10"
  //     ? "October"
  //     : "11"
  //     ? "November"
  //     : "12"
  //     ? "December"
  //     : "01"
  //     ? "January"
  //     : "");
  //   let dateYear = el.slice(0, 4);
  //   return dateNumber + " " + dateMonthValue + " " + dateYear;
  // }
  const [defaultValue, setdefaultValue] = useState(
    "Annual financial statements for the year ending"
  );
  const [CompanyName, setCompanyName] = useState("");
  const [CompanyDATE, setCompanyDATE] = useState("");

  useEffect(() => {
    let stop = false;
    if (stop) return;
    const db = getDatabase();
    let dataref =
      "BusinessDetails/" +
      uid +
      "/ClientCompanyAdded/" +
      companySelectedIdKey +
      "/coverPage";
    //
    let datarefYEARENDDATE =
      "BusinessDetails/" +
      uid +
      "/ClientCompanyAdded/" +
      companySelectedIdKey +
      "/yearEndDate";
    //
    let datarefName =
      "BusinessDetails/" +
      uid +
      "/ClientCompanyAdded/" +
      companySelectedIdKey +
      "/companyNameRef";
    //
    const coverRef = ref(db, dataref);
    const coverRefName = ref(db, datarefName);
    const coverRefDate = ref(db, datarefYEARENDDATE);
    onValue(coverRef, (snapshot) => {
      const data = snapshot.val();

      setdefaultValue(data);
    });
    onValue(coverRefName, (snapshot) => {
      const data = snapshot.val();

      setCompanyName(data);
    });
    onValue(coverRefDate, (snapshot) => {
      const data = snapshot.val();

      setCompanyDATE(data);
    });
    return () => {
      stop = true;
    };
  }, [uid, companySelectedIdKey]);

  //

  //  console.log("render");
  const handleState = (e) => {
    setdefaultValue(e.target.value);
  };
  const handleChange = (e) => {
    const db = getDatabase();
    update(
      ref(
        db,
        "BusinessDetails/" + uid + "/ClientCompanyAdded/" + companySelectedIdKey
      ),
      {
        coverPage: e.target.value,
      }
    )
      .then(() => {
        // Data saved successfully!
      })
      .catch((error) => {
        console.log(error);
        // The write failed...
      });
  };

  //
  if (noBusinessSelected === "true") {
    return (
      <div
        style={{
          minHeight: "100vh",
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        }}
      >
        <Navigation />

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "60vh",
            padding: "40px 20px",
          }}
        >
          <div
            style={{
              background: "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 20px 50px rgba(0, 0, 0, 0.15)",
              border: "1px solid rgba(255, 255, 255, 0.2)",
              backdropFilter: "blur(20px)",
              maxWidth: "600px",
              textAlign: "center",
              animation: "fadeInScale 0.6s ease-out",
            }}
          >
            <div
              style={{
                width: "80px",
                height: "80px",
                borderRadius: "50%",
                background: "linear-gradient(135deg, #ffc107 0%, #e0a800 100%)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "40px",
                margin: "0 auto 30px",
                boxShadow: "0 8px 25px rgba(255, 193, 7, 0.3)",
                animation: "bounce 2s infinite",
              }}
            >
              ⚠️
            </div>

            <div
              style={{
                marginBottom: "30px",
              }}
            >
              <div
                className="spinner-border text-primary"
                role="status"
                style={{
                  width: "3rem",
                  height: "3rem",
                  borderWidth: "4px",
                }}
              ></div>
            </div>

            <h3
              style={{
                color: "#495057",
                fontWeight: "600",
                marginBottom: "20px",
                fontSize: "1.5rem",
              }}
            >
              Business Selection Required
            </h3>

            <div
              style={{
                background: "linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)",
                border: "2px solid #90caf9",
                borderRadius: "12px",
                padding: "20px",
                color: "#1565c0",
                fontSize: "16px",
                lineHeight: "1.6",
                textAlign: "left",
              }}
            >
              <strong>📋 Please follow these steps:</strong>
              <ul style={{ margin: "15px 0 0 20px", padding: 0 }}>
                <li style={{ marginBottom: "8px" }}>
                  Navigate to the <strong>"Info"</strong> page
                </li>
                <li style={{ marginBottom: "8px" }}>
                  Select at least one business from the list
                </li>
                <li style={{ marginBottom: "8px" }}>
                  If no businesses appear, click <strong>"Add Entity"</strong>
                </li>
                <li>If cache was cleared, please login again</li>
              </ul>
            </div>
          </div>
        </div>

        <style jsx>{`
          @keyframes fadeInScale {
            from {
              opacity: 0;
              transform: scale(0.9);
            }
            to {
              opacity: 1;
              transform: scale(1);
            }
          }

          @keyframes bounce {
            0%,
            20%,
            50%,
            80%,
            100% {
              transform: translateY(0);
            }
            40% {
              transform: translateY(-10px);
            }
            60% {
              transform: translateY(-5px);
            }
          }
        `}</style>
      </div>
    );
  }

  //

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      }}
    >
      <Navigation
        colorNotesMenu="MediumBlue"
        stylingOnClickCover={stylingOnClickCover}
      />
      <NotesNav coverColor="MediumBlue" />

      {loadingApp1 && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "40px",
            background: "rgba(255, 255, 255, 0.1)",
            borderRadius: "15px",
            margin: "20px",
            backdropFilter: "blur(10px)",
          }}
        >
          <LinearIndeterminate />
        </div>
      )}

      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
          padding: "40px 20px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "30px",
        }}
      >
        {/* Notice Card */}
        <div
          style={{
            background: "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
            borderRadius: "20px",
            padding: "25px",
            boxShadow: "0 15px 40px rgba(0, 0, 0, 0.1)",
            border: "1px solid rgba(255, 255, 255, 0.2)",
            backdropFilter: "blur(20px)",
            width: "100%",
            maxWidth: "800px",
            animation: "slideInDown 0.6s ease-out",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "15px",
              marginBottom: "15px",
            }}
          >
            <div
              style={{
                width: "50px",
                height: "50px",
                borderRadius: "50%",
                background: "linear-gradient(135deg, #007bff 0%, #0056b3 100%)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "24px",
                color: "white",
                boxShadow: "0 4px 15px rgba(0, 123, 255, 0.3)",
              }}
            >
              ℹ️
            </div>
            <h6
              style={{
                margin: 0,
                color: "#495057",
                fontSize: "16px",
                fontWeight: "600",
                lineHeight: "1.5",
              }}
            >
              <strong>Note:</strong> Changes to the wording below reflects on
              the cover page of the AFS.
            </h6>
          </div>
        </div>

        {/* Main Cover Card */}
        <div
          style={{
            background: "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
            borderRadius: "25px",
            padding: "60px 40px",
            boxShadow: "0 25px 60px rgba(0, 0, 0, 0.15)",
            border: "1px solid rgba(255, 255, 255, 0.3)",
            backdropFilter: "blur(30px)",
            width: "100%",
            maxWidth: "900px",
            textAlign: "center",
            position: "relative",
            overflow: "hidden",
            animation: "slideInUp 0.8s ease-out",
          }}
        >
          {/* Decorative Background Elements */}
          <div
            style={{
              position: "absolute",
              top: "-50px",
              right: "-50px",
              width: "200px",
              height: "200px",
              borderRadius: "50%",
              background:
                "linear-gradient(135deg, rgba(0, 123, 255, 0.1) 0%, rgba(0, 86, 179, 0.05) 100%)",
              zIndex: 0,
            }}
          ></div>
          <div
            style={{
              position: "absolute",
              bottom: "-50px",
              left: "-50px",
              width: "150px",
              height: "150px",
              borderRadius: "50%",
              background:
                "linear-gradient(135deg, rgba(40, 167, 69, 0.1) 0%, rgba(32, 134, 55, 0.05) 100%)",
              zIndex: 0,
            }}
          ></div>

          {/* Content */}
          <div style={{ position: "relative", zIndex: 1 }}>
            {/* Company Name */}
            <h1
              style={{
                fontSize: "3.5rem",
                fontWeight: "700",
                background:
                  "linear-gradient(135deg, #2c3e50 0%, #3498db 50%, #2980b9 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
                marginBottom: "40px",
                lineHeight: "1.2",
                textShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                animation: "fadeInScale 1s ease-out 0.3s both",
              }}
            >
              {CompanyName || "Company Name"}
            </h1>

            {/* Financial Statement Title */}
            <div
              style={{
                marginBottom: "30px",
                animation: "fadeInScale 1s ease-out 0.6s both",
              }}
            >
              <input
                style={{
                  width: "100%",
                  maxWidth: "700px",
                  fontSize: "2rem",
                  fontWeight: "600",
                  color: "#2c3e50",
                  background:
                    "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
                  border: "3px solid transparent",
                  borderRadius: "15px",
                  padding: "20px 25px",
                  textAlign: "center",
                  boxShadow: "0 8px 25px rgba(0, 0, 0, 0.1)",
                  transition: "all 0.3s ease",
                  outline: "none",
                  backgroundImage:
                    "linear-gradient(white, white), linear-gradient(135deg, #007bff 0%, #28a745 100%)",
                  backgroundOrigin: "border-box",
                  backgroundClip: "content-box, border-box",
                }}
                value={defaultValue}
                onChange={handleState}
                onBlur={handleChange}
                onFocus={(e) => {
                  e.target.style.transform = "scale(1.02)";
                  e.target.style.boxShadow =
                    "0 15px 40px rgba(0, 123, 255, 0.2)";
                }}
                onBlur={(e) => {
                  handleChange(e);
                  e.target.style.transform = "scale(1)";
                  e.target.style.boxShadow = "0 8px 25px rgba(0, 0, 0, 0.1)";
                }}
                placeholder="Enter financial statement title..."
              />
            </div>

            {/* Date Display */}
            <div
              style={{
                fontSize: "1.8rem",
                fontWeight: "500",
                color: "#495057",
                background: "linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)",
                padding: "20px 30px",
                borderRadius: "15px",
                border: "2px solid #90caf9",
                boxShadow: "0 8px 25px rgba(33, 150, 243, 0.15)",
                animation: "fadeInScale 1s ease-out 0.9s both",
                position: "relative",
                overflow: "hidden",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  background:
                    "linear-gradient(45deg, transparent 30%, rgba(255, 255, 255, 0.1) 50%, transparent 70%)",
                  transform: "translateX(-100%)",
                  animation: "shimmer 2s infinite",
                }}
              ></div>
              <span
                style={{
                  position: "relative",
                  zIndex: 1,
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                📅{" "}
                {`${
                  newData.map((el1) => Object.keys(el1).length).toString() ===
                  "0"
                    ? "Select Year"
                    : CompanyDATE ||
                      newData.map((el5) => el5.yearSelected.replace(/-/g, "/"))
                }`}
              </span>
            </div>
          </div>

          {/* Decorative Bottom Line */}
          <div
            style={{
              position: "absolute",
              bottom: 0,
              left: "50%",
              transform: "translateX(-50%)",
              width: "60%",
              height: "4px",
              background:
                "linear-gradient(90deg, transparent 0%, #007bff 50%, transparent 100%)",
              borderRadius: "2px",
            }}
          ></div>
        </div>

        {/* Footer Decorative Element */}
        <div
          style={{
            marginTop: "40px",
            padding: "20px",
            textAlign: "center",
            color: "rgba(255, 255, 255, 0.8)",
            fontSize: "14px",
            animation: "fadeIn 1.2s ease-out 1s both",
          }}
        >
          <div
            style={{
              width: "100px",
              height: "2px",
              background:
                "linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.5) 50%, transparent 100%)",
              margin: "0 auto 15px",
              borderRadius: "1px",
            }}
          ></div>
          Professional Financial Statements
        </div>
      </div>

      <style jsx>{`
        @keyframes slideInDown {
          from {
            opacity: 0;
            transform: translateY(-50px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes slideInUp {
          from {
            opacity: 0;
            transform: translateY(50px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes fadeInScale {
          from {
            opacity: 0;
            transform: scale(0.9);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        @keyframes shimmer {
          0% {
            transform: translateX(-100%);
          }
          100% {
            transform: translateX(100%);
          }
        }

        /* Responsive Design */
        @media (max-width: 768px) {
          .main-cover-card h1 {
            font-size: 2.5rem !important;
          }

          .main-cover-card input {
            font-size: 1.5rem !important;
            padding: 15px 20px !important;
          }

          .date-display {
            font-size: 1.4rem !important;
            padding: 15px 20px !important;
          }
        }

        /* Enhanced Input Styling */
        input:focus {
          animation: pulse 0.6s ease-in-out;
        }

        @keyframes pulse {
          0% {
            box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
          }
          50% {
            box-shadow: 0 15px 40px rgba(0, 123, 255, 0.3);
          }
          100% {
            box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
          }
        }
      `}</style>
    </div>
  );
};

export default Cover;
